import useTwinTranslation from '../useTwinTranslation'
import { TwinDictionary } from '../../globals/dictionary'
import { PdfTemplatePdfTypesTy } from '@teinor/erp/types/company/config/pdfTemplate'

const useCSVTemplateTypes = () => {
    const { t } = useTwinTranslation()
    const csvTemplateTypes: Record<keyof PdfTemplatePdfTypesTy, TwinDictionary> = {
        'quoteOrder': { name: t('quoteOrder', 'Presupuesto'), url: '/api/app/order/quote/getQuoteOrderCsv' },
        'buyOrder': { name: t('buyOrdersL', 'Pedido de compras'), url: '/api/app/order/buy/buyOrder/getBuyOrderCsv' },
        'buyDeliveryNote': { name: t('buyDeliveryNotesL', 'Albarán de compras'), url: '/api/app/order/buy/buyDeliveryNote/getBuyDeliveryNoteCsv' },
        'buyInvoice': { name: t('buyInvoicesL', 'Factura de compras'), url: '/api/app/order/buy/buyInvoice/getBuyInvoiceCsv' },
        'sellOrder': { name: t('sellOrdersL', 'Pedido de ventas'), url: '/api/app/order/sell/sellOrder/getSellOrderCsv' },
        'sellDeliveryNote': { name: t('sellDeliveryNotesL', 'Albarán de ventas'), url: '/api/app/order/sell/sellDeliveryNote/getSellDeliveryNoteCsv' },
        'sellInvoice': { name: t('sellInvoicesL', 'Factura de ventas'), url: '/api/app/order/sell/sellInvoice/getSellInvoiceCsv' },
        'sellRefundInvoice': {},
        'sellRefundDeliveryNote': {},
        'ticket': { name:'', url: ''},
        'ticketPDF': { name:'', url: ''},
        'ticketRefund': { name:'', url: ''},
        'ticketRefundPDF': { name:'', url: ''},
        'customerMaterialStockOrder': { name:'', url: ''},
        'voucher': { name:'', url: ''},
        'voucherPDF': { name:'', url: ''},
        'giftTicket': { name:'', url: ''},
        'giftTicketPDF': { name:'', url: ''},
        'adjustmentDeliveryNote': { name: '', url: '' },
        'manufacturingPDF': { name: '', url: '' },
        'cashRegister': { name: '', url: ''},
        'reparation': { name: '', url: ''},
        'ticketReparation': { name: '', url: ''},
        'warehouseTransfer': { name: t('warehouseTransfer', 'Traspaso de almacen'), url: '/api/app/warehouse/warehouseTransfer/getWarehouseTransferCsv' },
        'productCertificate': { name: '', url: '' },

    }
    return { csvTemplateTypes }
}

export default useCSVTemplateTypes